import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Button from 'components/CustomButtons/Button.js'
import Footer from 'components/Footer/Footer.js'

import {
  ethEnabled,
  listenForAccountsChange,
  listenForChainChange,
} from 'eth/ethUtils'
import {
  setMintStage
} from 'redux/actions/nftActions'
import { HelpOutlineTwoTone } from '@material-ui/icons'

import NumericInputField from 'components/NumericInputField'
import { getLocalPrice } from 'eth/ethUtils'

import CheckForWallet from 'components/nft/CheckForWallet'

import MintNFTStart from 'components/mint/MintNFTStart'
import MintNFTInProgress from 'components/mint/MintNFTInProgress'
import { getETHRate, getHarmonizeContract } from 'eth/ethUtils'
import { getOptionsMintFee } from 'eth/tokenUtils'
import MintNFTRoyalty from 'components/mint/MintNFTRoyalty'
import ErrorLine from 'components/ErrorLine'
import { getOptionsIsRunning } from 'eth/tokenUtils'
import { getBrandName } from 'util/brandUtils'
import { getDisplayType } from 'redux/actions/displayActions'

import HarmonizeHeader from 'components/Header/HarmonizeHeader'
import { MINT_STAGES } from 'redux/reducers/nftReducer'
import { useHistory, useParams } from 'react-router-dom'
import { getMessage } from 'controllers/SocialServiceController'
import Explain from 'components/Explain'
import { setNFTMessage } from 'redux/actions/nftActions'
import { getAccountBalanceEth } from 'eth/ethUtils'
import { setNFTPrice } from 'redux/actions/nftActions'
import { getOptionsAllowRoyalty } from 'eth/tokenUtils'
import { isVeryNarrow } from 'util/screenUtils'
import { useMediaQuery } from '@material-ui/core'
import { v4 as uuidv4 } from 'uuid'
import { setTokenId } from 'redux/actions/nftActions'
import { setNFTName } from 'redux/actions/nftActions'
import { setNFTDescription } from 'redux/actions/nftActions'
import { setNFTMessageId } from 'redux/actions/nftActions'
import { getNFTForMessage } from 'controllers/NFTController'
import { updateNFT } from 'redux/actions/nftActions'
import { store } from 'index'
import { resetNFT } from 'redux/actions/nftActions'
import { TX_STATUS } from 'eth/tokenUtils'
import { getUint256StringFromUUID } from 'eth/tokenUtils'
import DisplayNFTInfo from 'components/nft/DisplayNFTInfo'

export const getFirstMintStage = () => {
  return MINT_STAGES.START
}
let harmonizeContract
export default function MintNFT() {
  const { messageId } = useParams()
  const veryNarrow = isVeryNarrow(useMediaQuery)
  const dispatch = useDispatch()
  const [currentAccount, setCurrentAccount] = useState()
  const [accountBalance, setAccountBalance] = useState()
  const [mintFee, setMintFee] = useState()
  const [explainTokens, setExplainTokens] = useState(false)
  const [explainPrice, setExplainPrice] = useState(false)
  const [helpTarget, setHelpTarget] = useState()
  const { mintStage, nftMessage, price, tokenId } = useSelector(state => state.nfts)
  const [nftStatus, setNftStatus] = useState(undefined)

  const { currency, showMintingDefaults } = useSelector(
    (state) => state.settings
  )

  const [ethInCurrency, setEthInCurrency] = useState(0)

  const [error, setError] = useState()
  const [contractIsRunning, setContractIsRunning] = useState(undefined)
  const [allowRoyalty, setAllowRoyalty] = useState(false)
  const history = useHistory()

  const displayError = (error) => {
    const { message } = error
    if (message) {
      if (message.toLowerCase().includes('user denied')) {
        setError()
      } else {
        setError(message)
      }
    } else {
      setError(JSON.stringify(error))
    }
  }
  const displayExplainPrice = () => {
    if (explainPrice) {
      const { name } = nftMessage
      return (
        <Explain
          source={{
            description: `<p>Set a price in ETH for <i>${name}</i>. The price displayed
            in your local currency will change as the current market value for ETH changes.
            </p>
            <p>
            If you set a non-0 price, anyone with a valid Ethereum account and sufficent ETH can purchase this NFT. A price of 0
            means the NFT is not for sale.</p>
            <p>Once the NFT is minted, you can still change the price. You will be charged
            network fees (gas and transaction fee, if any) when you update the price after minting.`,
          }}
          target={helpTarget}
          close={() => setExplainPrice(false)}
        />
      )
    }
  }
  const displayExplainTokens = () => {
    if (explainTokens) {
      const { name } = nftMessage
      return (
        <Explain
          source={{
            description: `To create an NFT for <i>${name}</i>, you need an Ethereum account 
            with enough ETH currency to pay for this mint`,
          }}
          target={helpTarget}
          close={() => setExplainTokens(false)}
        />
      )
    }
  }

  /**
   * @param {*} value
   */
  const updatePrice = (value) => {
    dispatch(setNFTPrice(value))
  }
  const displayPrice = () => {
    return (
      <div style={{
        display: 'flex', width: '50vw', flexDirection: 'column',
        marginLeft: 'auto', marginRight: 'auto'
      }}>

        <h4 style={{ textAlign: 'center' }}>
          <HelpOutlineTwoTone
            style={{ height: '100%', verticalAlign: 'middle' }}
            size='small'
            color='primary'
            onClick={(event) => {
              setHelpTarget(event.currentTarget)
              setExplainPrice(!explainPrice)
            }}
          />
          Sale Price
        </h4>
        <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
          <div style={{ width: veryNarrow ? '100%' : '50%' }}>
            <NumericInputField
              helper={price<=0?'Not for sale':`NFT Sale Price (\u{039E})`}
              min={0}
              max={parseInt(process.env.REACT_APP_MAX_TOKEN_PRICE_ETH)}
              getter={() => {
                return price
              }}
              step={0.01}
              setter={updatePrice}
            />
          </div>
          <div>{getLocalPrice(price, ethInCurrency, currency)}</div>
        </div>
      </div>
    )

  }

  const displayMint = () => {
    const disabled =
      !contractIsRunning || error !== undefined

    return (
      <div style={{ display: 'flex', width: '90vw', justifyContent: 'space-between' }}>
        <Button
          color="info"
          title='Go back'
          style={{ cursor: 'pointer' }}
          onClick={() => history.goBack()}>
          Close
        </Button>
        {!error ? <Button
          disabled={disabled}
          color="primary"
          title='Continue minting'
          style={{ cursor: 'pointer' }}
          onClick={() => dispatch(setMintStage(MINT_STAGES.START))}
        >
          Continue
        </Button> : null}
      </div>
    )
  }

  const displayHeader = () => {
    if (nftMessage) {
      const { name } = nftMessage
      return (
        <div>
          <h3 style={{ textAlign: 'center' }}>
            <HelpOutlineTwoTone
              style={{ height: '100%', verticalAlign: 'middle' }}
              size='small'
              color='primary'
              onClick={(event) => {
                setHelpTarget(event.currentTarget)
                setExplainTokens(!explainTokens)
              }}
            />
            Mint NFT
          </h3>
          <h4 style={{ textAlign: 'center' }}>{name}</h4>
          <DisplayNFTInfo tokenId={tokenId} currentAccount={currentAccount}
            accountBalance={accountBalance} />

        </div>
      )
    }
  }

  const displayMintedOrReadyToMint = () => {
    switch (nftStatus) {
      default:
        return null
      case TX_STATUS.NONE:
        return (
          <div>
            {allowRoyalty ? <MintNFTRoyalty /> : null}
            {displayPrice()}
            {displayMint()}
          </div>
        )
      case TX_STATUS.COMPLETED:
        return (
          <div style={{
            display: 'flex', flexDirection: 'column',
            width: '90vw', marginLeft: 'auto', marginRight: 'auto'
          }}>
            <h4 style={{ textAlign: 'center' }}>This NFT has been minted</h4>
            <Button
              color="info"
              title='Go back'
              style={{ cursor: 'pointer' }}
              onClick={() => history.goBack()}>
              Close
            </Button>

          </div>
        )

    }
  }
  const displayBody = () => {
    return (
      <div style={{ paddingBottom: '.5em' }}>
        {displayHeader()}
        {displayMintedOrReadyToMint()}
        {displayExplainTokens()}
        {displayExplainPrice()}

      </div>
    )
  }
  const displayStage0 = () => {
    return (
      <div style={{ paddingLeft: '1em', paddingRight: '1em', paddingBottom: '10vh' }}>
        <ErrorLine error={error} />
        {currentAccount ? <CheckForWallet
          render={() => {
            return displayBody()
          }}
        /> : null}

      </div>
    )

  }

  const checkValidMinting = () => {
    if (contractIsRunning === false) {
      setError(`${getBrandName(getDisplayType())} contract is not running`)
    }
  }

  const setupEth = async () => {
    try {
      console.log('MintNFT setupEth')
      harmonizeContract = getHarmonizeContract()
      const ethAccount = await ethEnabled()
      console.log(`getAccountAndAsset ${ethAccount}`)
      setCurrentAccount(ethAccount)
      if (ethAccount) {
        setCurrentAccount(ethAccount)
        const balance = await getAccountBalanceEth()
        setAccountBalance(balance)
        listenForAccountsChange()
        listenForChainChange()
        getOptions()
      }
      const rate = await getETHRate(currency)
      setEthInCurrency(rate)
    } catch (error) {
      console.error('setupEth error', error)
      if (error.code === -32002) {
        displayError({
          message:
            'There is a Metamask connection request waiting for your response. Please tap the Metamask icon to continue.',
        })
      } else {
        displayError(error)
      }
    }
  }

  const displayStage = () => {
    console.log(`displayStage ${mintStage}`)
    switch (mintStage) {
      default:
      case MINT_STAGES.INIT:
        return displayStage0()

      case MINT_STAGES.START:
        return <MintNFTStart />
      case MINT_STAGES.PROGRESS:
        return <MintNFTInProgress />
    }
  }
  const displayMain = () => {
    return (
      <>
        <HarmonizeHeader />

        {displayStage()}

        <Footer />
      </>
    )
  }
  const getOptions = () => {
    if (harmonizeContract) {
      harmonizeContract.methods
        .options()
        .call()
        .then((opts) => {
          setContractIsRunning(getOptionsIsRunning(opts))
          setAllowRoyalty(getOptionsAllowRoyalty(opts))
          const fee = getOptionsMintFee(opts)
          setMintFee(fee)
          checkValidMinting()
        })
    }
  }
  useEffect(() => {
    const fetchMessage = async () => {
      let nft, ok = true
      try {
        nft = await getNFTForMessage(messageId)
      } catch (error) {
        console.log(`getnft error`, error)
        if (error.status !== 404) {
          ok = false
          displayError(error, setError)
        }
      }
      if (ok) {
        if (nft) {
          console.log('MintNFT got existing NFT', nft)
          const { txStatus } = nft
          setNftStatus(txStatus)
          dispatch(resetNFT())
          dispatch(updateNFT(nft))
          const socialServiceMessage = await getMessage(messageId)
          dispatch(setNFTMessage(socialServiceMessage))
          console.log('...updated state', store.getState().nfts)
        } else {
          dispatch(resetNFT())
          setNftStatus(TX_STATUS.NONE)
          const socialServiceMessage = await getMessage(messageId)
          dispatch(setNFTMessage(socialServiceMessage))
          const { name, message } = socialServiceMessage
          dispatch(setNFTName(name))
          dispatch(setNFTDescription(message))
          dispatch(setNFTMessageId(messageId))
          const tokenId = getUint256StringFromUUID(uuidv4())
          dispatch(setTokenId(tokenId))
        }
      }
      if (!currentAccount) {
        setupEth()
      } else {
        getOptions()
      }
    }

    fetchMessage()

  }, [])

  if (process.env.REACT_APP_MODE == 'development') {
    return displayMain()
  } else {
    return <div onContextMenu={(e) => e.preventDefault()}>{displayMain()}</div>
  }
}
